import { useCallback, useState } from 'react';
import { useAuth as useOidcAuth } from 'react-oidc-context';

import { logout } from '../utils/userAuthUtils';

type UseUserAuthProps = {
	onLogout?: () => void;
};

export const useUserAuth = (props?: UseUserAuthProps) => {
	// State
	// ------------------------------------------------------------------------

	const [isLoggingOut, setIsLoggingOut] = useState(false);

	// Hooks
	// ------------------------------------------------------------------------

	/** OIDC auth. */
	const { isLoading, isAuthenticated, signinRedirect, user, activeNavigator } = useOidcAuth();

	// Methods
	// ------------------------------------------------------------------------

	/** Get the access token. */
	const getAccessToken = useCallback(() => user?.access_token, [user?.access_token]);

	/** Handle user logout.  */
	const onLogout = useCallback(async () => {
		setIsLoggingOut(true);
		await props?.onLogout?.();
		await logout();
	}, [props]);

	return {
		login: signinRedirect,
		logout: onLogout,
		isLoading: isLoading || isLoggingOut,
		isAuthenticated,
		getAccessToken,
		user,
		activeNavigator,
	};
};
